module.exports = __webpack_public_path__ + "static/media/indiaMapImage.7565895e.png";